import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=cc144134&scoped=true&"
import script from "./TransferRecord.vue?vue&type=script&lang=js&"
export * from "./TransferRecord.vue?vue&type=script&lang=js&"
import style0 from "./TransferRecord.vue?vue&type=style&index=0&id=cc144134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc144134",
  null
  
)

export default component.exports